(function (app) {
  $(document).ready(function () {

    app.InsightWordCloud = function () {

      var _this = this;

      var nameSpace = 'InsightWordCloud',
        context = '.page__insight-word-cloud--container'
        ;

      /**
       *
       * @param url
       * @param callback
       * @returns {*}
       */
      _this.get = function (url, callback) {
        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            callback(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(url);
        return query.promise();
      };


      _this.getUrl = function (url, category) {
        if (_.isUndefined(category)) {
          return url;
        } else {
          return url + '?' + 'category=' + category;
        }

      };

      _this.generateCloud = function ($dataBody, words) {
        var cloud = d3.layout.cloud;

        var ranges = ['schemePaired', 'schemeCategory10'];
        var range = ranges[Math.floor(Math.random() * Math.floor(1))];

        var color = d3.scaleLinear()
          .domain([0, 1, 2, 3, 4, 5, 6, 10, 15, 20, 100])
          .range(eval('d3.' + range));

        words = words.map(function (d) {
          return {text: d.text, size: 10 + Math.random() * d.size};
        });
        var layout = cloud().size([960, 500])
          .words(words)
          .padding(5)
          .rotate(function () {
            return ~~(Math.random() * 2) * 90;
          })
          .font("Impact")
          .fontSize(function (d) {
            return d.size;
          })
          .on("end", draw);


        layout.start();

        function draw(words) {

          d3.select($dataBody[0]).append("svg")
            .attr("width", layout.size()[0])
            .attr("height", layout.size()[1])
            .append("g")
            .attr("transform", "translate(" + layout.size()[0] / 2 + "," + layout.size()[1] / 2 + ")")
            .selectAll("text")
            .data(words)
            .enter().append("text")
            .style("font-size", function (d) {
              return d.size + "px";
            })
            .style("font-family", "Impact")
            .attr("text-anchor", "middle")
            .style("fill", function (t, i) {
              return color(i);
            })
            .attr("transform", function (d) {
              return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
            })
            .text(function (d) {
              return d.text;
            });
        }

      };

      /**
       * Get Word Cloud
       */
      _this.getWordCloud = function (category) {
        var $dataBody = $('.word-cloud-container', $(context));
        $dataBody.html('');
        $dataBody.addClass('m-progress');

        _this.get(_this.getUrl('/api/insight/word-cloud', category), function (response) {
          $dataBody.removeClass('m-progress');
          _this.generateCloud($dataBody, response);
        })
      };


      return {
        init: function () {

          _this.getWordCloud();

          $(document).off('change.search__' + nameSpace).on('change.search__' + nameSpace, context + ' select[name=category]', function (e) {

            var category = $(this).val();
            _this.getWordCloud(category);
          });

        }
      };
    };
  });
})(PreBuilt);

